import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  httpClient,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { SameDayHourSuggest, SameDayHourSuggestRequest } from './types';
import { apiRoutes } from '@/api/api-routes';

export const samedayHourSuggestFn = async (
  body: SameDayHourSuggestRequest,
  config: AxiosRequestConfig = {}
) => {
  const { signal, headers } = config;

  const response = await httpClient.post<SameDayHourSuggest[]>(
    apiRoutes.service.samedayHourSuggest,
    body,
    {
      signal,
      headers: {
        ...headers,
        'accepts-version': 2,
      },
    }
  );

  return response.data;
};

export const useSamedayHourSuggestMutation = (
  opts?: UseMutationOptions<
    SameDayHourSuggest[],
    DefaultQueryError,
    SameDayHourSuggestRequest
  >
) =>
  useMutation<
    SameDayHourSuggest[],
    DefaultQueryError,
    SameDayHourSuggestRequest
  >({
    mutationFn: samedayHourSuggestFn,
    ...opts,
  });
